import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientBusinessService } from 'src/app/core/business/client/client-business.service';

@Injectable({
  providedIn: 'root'
})
export class ClientFacadeService {

  constructor(
    private clientBusinessService: ClientBusinessService
  ) { }

  onboardClient(data) {
    return this.clientBusinessService.onboardStylist(data);
  }

  updateOnboardClient(data): Observable<any> {
    return this.clientBusinessService.updateOnboardClient(data);
  }

  getClientById(id): Observable<any> {
    return this.clientBusinessService.getClientById(id);
  }

  checkEmailFBandDB(email): Observable<any> {
    return this.clientBusinessService.checkEmailFBandDB(email);
  }
}
